import { Box } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

import BankWithdrawV2 from "./components/BankWithdrawV2";

const WithdrawStepOne = ({ washConfig, selectedCurrency }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`withdraw.${key}`);

  return (
    <BankWithdrawV2
      washConfig={washConfig}
      selectedCurrency={selectedCurrency}
    />
  );
};

export default WithdrawStepOne;
